import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import { siteFilesQuery, SiteFilesQueryResult } from './queries/siteFilesQuery';

type SiteFilesQueryParams = { projectId: string };

const siteFilesGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        siteFiles: builder.query<SiteFilesQueryResult['getProjectSummary']['files'], SiteFilesQueryParams>({
            query: params => ({
                body: siteFilesQuery,
                variables: { projectId: params.projectId },
            }),
            transformResponse: response => response.getProjectSummary.files,
            providesTags: (_result, _error, arg) => [{ type: 'project', id: arg.projectId }],
        }),
    }),
});

export const { useSiteFilesQuery } = siteFilesGraphSlice;

export default siteFilesGraphSlice;
